const DEBUG_VERBOSE = false;
const CLASS_NAME = `MenuItem`;

import gsap from 'gsap';

export default class MenuItem {
	public anchorEl!: HTMLAnchorElement;

	private timeline!: gsap.core.Timeline;

	constructor(public menuItemEl: HTMLElement) {
		this.anchorEl = this.menuItemEl.querySelector('a') as HTMLAnchorElement;

		if (!this.anchorEl) throw new Error('Unable to derive anchor!');

		// -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> ->

		this.init();

		this.addEventListeners();
	}

	// ////////////////////////////////////////////////////////////////////

	addEventListeners() {
		DEBUG_VERBOSE && console.log(CLASS_NAME, this.menuItemEl.id, 'addEventListeners', `this.isActive`, this.isActive);

		this.menuItemEl.addEventListener('mouseenter', this.onMouseEnter, { passive: true });
		this.menuItemEl.addEventListener('mouseleave', this.onMouseLeave, { passive: true });
	}

	// ////////////////////////////////////////////////////////////////////

	init() {
		DEBUG_VERBOSE && console.log(CLASS_NAME, this.menuItemEl.id, 'init', `this.isActive`, this.isActive);

		if (this.isActive) {
			gsap.set(this.anchorEl, { backgroundPosition: '100% 100%', backgroundSize: '100% 1px' });
		} else {
			gsap.set(this.anchorEl, { backgroundPosition: '100% 100%', backgroundSize: '0% 1px' });
		}
	}

	// ////////////////////////////////////////////////////////////////////

	onMouseEnter = (_event: MouseEvent) => {
		DEBUG_VERBOSE &&
			console.log(
				CLASS_NAME,
				this.menuItemEl.id,
				'onMouseEnter',
				`this.isActive`,
				this.isActive,
				`this.hasChildren`,
				this.hasChildren,
				performance.now()
			);

		if (this.isActive && this.hasChildren) {
			return;
		}

		// -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> ->

		if (this.timeline) this.timeline.kill();

		this.timeline = gsap.timeline({
			defaults: {
				ease: 'none',
			},
		});

		if (this.isActive) {
			// Remove and re-draw the line
			this.timeline.set(this.anchorEl, { backgroundPosition: '100% 100%', backgroundSize: '100% 1px' });
			this.timeline.to(this.anchorEl, { backgroundSize: '0% 1px', duration: 0.4 });
			this.timeline.set(this.anchorEl, { backgroundPosition: '0% 100%', backgroundSize: '0% 1px' });
			this.timeline.to(this.anchorEl, { backgroundSize: '100% 1px', duration: 0.4 }, '+=0.2');
			this.timeline.totalDuration(0.5);
		} else {
			this.timeline.set(this.anchorEl, { backgroundPosition: '0% 100%' });
			this.timeline.to(this.anchorEl, { backgroundSize: '100% 1px', duration: 0.25 });
		}
	};

	// ////////////////////////////////////////////////////////////////////

	onMouseLeave = () => {
		DEBUG_VERBOSE && console.log(CLASS_NAME, this.menuItemEl.id, 'onMouseLeave', this.isActive, performance.now());

		if (!this.isActive) {
			if (this.timeline) this.timeline.kill();

			this.timeline = gsap.timeline({
				defaults: {
					ease: 'none',
				},
				onComplete: () => {
					gsap.set(this.anchorEl, { clearProps: 'all' });
				},
			});

			this.timeline.set(this.anchorEl, { backgroundPosition: '100% 100%' });

			this.timeline.to(this.anchorEl, { backgroundSize: '0% 1px', duration: 0.25 });
		}
	};

	// ////////////////////////////////////////////////////////////////////

	get isActive() {
		return this.menuItemEl.classList.contains('current-menu-item') || this.menuItemEl.classList.contains('current-page-ancestor');
	}

	// ////////////////////////////////////////////////////////////////////

	get hasChildren() {
		return this.menuItemEl.classList.contains('menu-item-has-children');
	}
}
